<template>
  <div class="box" @click="goLaunch">
    <span>退出</span>
  </div>
</template>

<script>
import router from "../../router";
import common from "@/common";

export default {
  name: "QuitButton",
  props: {
    content_1: {type: String, default: ''},
    content_2: {type: String, default: ''},
  },
  methods: {
    goLaunch: function () {
      common.showConfirm(this.content_1+'<br><br>'+this.content_2, '確認退出', function () {
        common.getToken().then(value => {
          if (value == null) {
            router.replace('/login')
          } else {
            router.replace('/home')
          }
        })
      })


    }
  }
}
</script>

<style scoped>
  .box{
    position: fixed;
    top: calc(env(safe-area-inset-top) + 0.75rem);
    right: calc(env(safe-area-inset-right) + 0.75rem);
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: clamp(2.75rem, 6vw, 3.5rem);
    height: clamp(2rem, 4vw, 3rem);
    padding: 0 clamp(0.625rem, 1.5vw, 0.875rem);
    color: white;
    font-size: var(--ecs-font-md);
    line-height: 1.2;
    background: rgba(97, 0, 95, 0.82);
    border-radius: 999px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    cursor: pointer;
  }
</style>
